/* تبديل الحجم داخل دليل الأنواع.
   يحدّث الصف الواحد فقط، فبقية المنتجات تحتفظ باختيارها. */
(function(){
  document.querySelectorAll('.idx[data-p2]').forEach(function(row){
    var btns = row.querySelectorAll('[data-size]');
    if (!btns.length) return;
    var priceEl = row.querySelector('.idx-price');
    var smallEl = priceEl ? priceEl.querySelector('small') : null;
    var addBtn  = row.querySelector('[data-bag]');
    var imgLink = row.querySelector('.idx-img');
    var nameLink= row.querySelector('.idx-name a');

    btns.forEach(function(b){
      b.addEventListener('click', function(){
        if (b.disabled) return;
        var n = b.dataset.size;
        btns.forEach(function(x){ x.setAttribute('aria-pressed', String(x === b)); });

        var id    = row.dataset['p' + n];
        var price = row.dataset['p' + n + 'Price'];
        var url   = row.dataset['p' + n + 'Url'];
        var label = b.getAttribute(document.documentElement.dir === 'rtl' ? 'data-ar' : 'data-en');

        if (priceEl) {
          priceEl.childNodes[0].nodeValue = price + ' ';
          if (smallEl) {
            smallEl.setAttribute('data-en', b.getAttribute('data-en'));
            smallEl.setAttribute('data-ar', b.getAttribute('data-ar'));
            smallEl.innerHTML = label;
          }
        }
        if (addBtn) addBtn.dataset.bag = id;
        if (imgLink) imgLink.href = url;
        if (nameLink) nameLink.href = url;
      });
    });
  });
})();
